import { Component, OnInit, OnDestroy, ViewChild, ElementRef, DoCheck, AfterViewInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { SidenavService } from 'src/app/services/sidenav.service';
import { AppStateProvider } from 'src/app/services/app-state.provider';
import { Subscription } from 'rxjs';
import { NgbModal, ModalDismissReasons, NgbCalendar, NgbDate, NgbDateAdapter, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { Dimensions, ImageCroppedEvent, ImageTransform } from 'ngx-image-cropper';
import { DomSanitizer } from '@angular/platform-browser';
import { Pollsandsurvey } from 'src/app/model/pollsandsurvey.model';
import { PollsandsurveyService } from 'src/app/services/pollsandsurvey.service';
import { DateService } from 'src/app/services/date.service';
import { DatePipe } from '@angular/common';

@Component({
  standalone: false,
  selector: 'app-update-survey-question',
  templateUrl: './update-survey-question.component.html',
  styleUrls: ['./update-survey-question.component.scss']
})
export class UpdateSurveyQuestionComponent implements OnInit {

  public pollsandsurvey = new Pollsandsurvey();
  private subscriptions = new Subscription();

  surveyId: any;
  surveyDetails: any;
  groupId: string = null;
  fromDetailsPage: any;
  checkedOnlyUsersList: any;
  couponlogo = 'couponlogo';
  tempDate: any;
  singleCouponId = [];
  fromListPage = 'no';
  formatDate: any;
  selectedDate: any;
  selectedToDate: any;
  formattedSelectedDate: string = '';
  formattedSelectedToDate: string = '';
  fromDate: any;
  fDate: any;
  toDate: any;
  tDate: string;
  mainCouponList = [];
  prakList: any = [];
  parkName: any;
  couponName: any;
  parkId: any;
  public sharedDataNew: any;
  surveyName: any;
  questionTypes = [];
  finalSubmissionArray = [];
  surveyQuestion = [];
  responses = [];
  showPreview: boolean = false;
  arrayForPreview: any;
  mainquestionAnswerList = [];
  showPreviewFromApi: boolean = false;

  surveyForm: FormGroup;

  myForm!: FormGroup;

  constructor(
    private pollsandsurveyService: PollsandsurveyService,
    public datepipe: DatePipe,
    private formBuilder: FormBuilder,
    private router: Router,
    private sideNavService: SidenavService,
    private appStateSrv: AppStateProvider,
    private modalService: NgbModal,
    private sanitizer: DomSanitizer,
    private acroute: ActivatedRoute,
    private dateAdapter: NgbDateAdapter<string>,
    private dateSrv: DateService,
    private ngbCalendar: NgbCalendar,
    private route: ActivatedRoute
  ) {
    this.myForm = this.formBuilder.group({
      newQuestionGroups: this.formBuilder.array([this.newNotes()]),
      createdBy: '',
      isActive: true,
      questionAnswers: this.formBuilder.array([this.newNotes()]),
    });

    localStorage.setItem('expandNavCreateview', 'true');
    const routeLink = this.sideNavService.routingChunks({
      name: 'Create and View',
      subNav: '1',
      subNavLink: '',
    });
    this.appStateSrv.setSideNavState(routeLink);

    this.questionTypes.push(
      {
        questionType: '1',
        questionName: 'Radio Button',
      },
      {
        questionType: '3',
        questionName: 'Checkbox',
      },
      {
        questionType: '2',
        questionName: 'Short Answer',
      }
    );
  }

  ngOnInit(): void {

    localStorage.removeItem('expandNav');
    localStorage.removeItem('expandNavLand');

    this.showPreview = false;

    this.pollsandsurvey.questionType = '';

    this.route.params.subscribe((params) => {
      this.surveyId = params['id'];
    });

    const jsDate = new Date();
    this.selectedDate = this.datepipe.transform(jsDate, 'MM/dd/yyyy');
    this.formattedSelectedDate = this.dateSrv.convertDateToLocaleString(
      new Date().getDate(),
      new Date().getMonth(),
      new Date().getFullYear()
    );
    this.selectedToDate = this.datepipe.transform(jsDate, 'MM/dd/yyyy');
    this.formattedSelectedToDate = this.dateSrv.convertDateToLocaleString(
      new Date().getDate(),
      new Date().getMonth(),
      new Date().getFullYear()
    );
    this.fromDate = new Date(jsDate.toLocaleDateString('en-US'));
    this.toDate = new Date(jsDate.toLocaleDateString('en-US'));
    this.fDate = this.updateDateToCalendar();
    this.tDate = this.updateDateToCalendar();

    this.getSurveyDetailsSingle();
    // this.getParkDetails();
    this.getTheCouponsList();
    this.getThisSurveyQuestionSet();

    // this.pollsandsurveyService.getOptionDynamic.subscribe((data) => {
    //   this.sharedDataNew = data;
    //   if (
    //     typeof this.sharedDataNew.surveyName == undefined ||
    //     this.sharedDataNew.surveyName == 'undefined'
    //   ) {
    //     setTimeout(() => {
    //       this.surveyName = '';
    //     }, 300);
    //   } else {
    //     setTimeout(() => {
    //       this.surveyName = this.sharedDataNew.survey_name;
    //     }, 300);
    //   }
    // });

    this.surveyName = localStorage.getItem('survey_name');

    // this.pollsandsurveyService.setOptionDynamic('surveyName', this.surveyName);

    this.surveyForm = this.formBuilder.group({
      questions: this.formBuilder.array([]),
    });
  }

  getThisSurveyQuestionSet() {
    this.pollsandsurveyService.getAllSurveyQuestionAnswer(this.surveyId).subscribe((res) => {
      if (res?.data) {
        this.arrayForPreview = res?.data.questions;
        this.showPreviewFromApi = true;

        for (let i = 0; i <= this.arrayForPreview?.length - 1; i++) {
          (this.surveyForm.get('questions') as FormArray).push(
            this.createQuestion(
              this.arrayForPreview[i].surveyQuestion,
              this.arrayForPreview[i].answerType,
              this.arrayForPreview[i].responses,
              this.arrayForPreview[i].questionId,
            ));
          for (let j = 0; j <= this.arrayForPreview[i].responses?.length - 1; j++) {
            ((this.surveyForm.get('questions') as FormArray).controls[i].get('answers') as FormArray).push(
              this.createAnswer(
                this.arrayForPreview[i].responses[j].responseText,
                this.arrayForPreview[i].responses[j].responseId,
              ));
          }
        }
      }
    });
  }

  getSurveyDetailsSingle() {
    this.pollsandsurveyService
      .getSurveyAttributes(this.surveyId)
      .subscribe((res) => {
        if (res?.isValid === true) {
          this.surveyDetails = res;
        }
      });
  }

  get questionsArray() {
    return (this.surveyForm.get('questions') as FormArray).controls;
  }

  createQuestion(questionText?: string, answerType?: any, responses?: any, questionId?: any): FormGroup {
    return this.formBuilder.group({
      questionId: [questionId ? questionId : ''],
      questionText: [questionText ? questionText : '', Validators.required],
      questionType: [answerType ? answerType?.toString() : '', Validators.required],
      answers: responses ? this.formBuilder.array([]) : this.formBuilder.array([this.createAnswer()]),
    });
  }

  createAnswer(responses?: any, responseId?: any): FormGroup {
    return this.formBuilder.group({
      answerText: [responses ? responses : '', Validators.required],
      responseId: [responseId ? responseId : null],
    });
  }

  addQuestion() {
    (this.surveyForm.get('questions') as FormArray).push(this.createQuestion());
  }

  removeQuestion(index: number) {
    (this.surveyForm.get('questions') as FormArray).removeAt(index);
  }

  addAnswer(question: FormGroup) {
    // const options = question.get('answers') as FormArray;
    // options.push(this.createAnswer());
    (question.get('answers') as FormArray).push(this.createAnswer());
  }

  removeAnswer(question: FormGroup, index: number) {
    // const options = question.get('answers') as FormArray;
    // options.removeAt(index);
    (question.get('answers') as FormArray).removeAt(index);
  }

  clearAnswer(question: any, i: any) {
    question.controls.answers.controls[0].controls.answerText.value = '';
    // this.surveyForm.reset();
  }

  onSubmit() {
    this.showPreview = false;
    // this.arrayForPreview = [];
    if (this.surveyForm.valid) {
      // Handle form submission logic here
      const formValue = this.surveyForm.value;

      this.finalSubmissionArray = [];
      this.surveyQuestion = [];
      this.responses = [];
      for (let i = 0; i < formValue.questions.length; i++) {
        this.surveyQuestion.push({
          "QuestionId": formValue.questions[i].questionId ? formValue.questions[i].questionId : null,
          "QuestionSerial": i + 1,
          "answerLength": formValue.questions[i].questionType == 2 ? parseInt(formValue.questions[i].answers[0].answerText) : null,
          "answerType": parseInt(formValue.questions[i].questionType),
          "surveyQuestion": formValue.questions[i].questionText,
          "responses": formValue.questions[i].answers
        });
      }

      this.finalSubmissionArray.push(
        {
          "surveyId": this.surveyId,
          "createdBy": parseInt(localStorage.getItem('claAdminId')),
          "questions": this.surveyQuestion,
        }
      );

      if (this.finalSubmissionArray[0]) {
        this.arrayForPreview = this.finalSubmissionArray[0].questions;
        this.showPreview = true;
      }

      // this.pollsandsurveyService
      //   .addPollsAndSurveyQuestion(this.finalSubmissionArray[0])
      //   .subscribe((res) => {
      //     this.router.navigate(['/list-survey/']);
      //   });



      // Remove options for short answer questions
      // formValue.questions.forEach((question: any) => {
      //   if (question.type === 'shortAnswer') {
      //     delete question.answers;
      //   }
      // });
    } else {
      this.surveyForm.markAllAsTouched();
    }
  }

  submitFinalData(submitFinalData: any) {
    console.log(submitFinalData[0]);
    this.pollsandsurveyService
      .addPollsAndSurveyQuestion(submitFinalData[0])
      .subscribe((res) => {
        this.router.navigate(['/list-survey/']);
      });
  }
  // survey question section end

  ngOnDestroy() {
    localStorage.removeItem('expandNavCreateview');
    this.subscriptions.unsubscribe();
  }

  newQuestionGroups(): FormArray {
    return this.myForm.get('newQuestionGroups') as FormArray;
  }

  questionAnswers(): FormArray {
    return this.myForm.get('questionAnswers') as FormArray;
  }

  newNotes(): FormGroup {
    return this.formBuilder.group({
      question: ['', Validators.required],
      questionType: ['', Validators.required],
    });
  }

  addMore(): void {
    this.newQuestionGroups().push(this.newNotes());
  }

  removeBlock(i: number) {
    this.newQuestionGroups().removeAt(i);
  }

  assignQuestionType(event, index) {
    if (event.target.value == '3' || event.target.value == '1') {
    }
  }

  updateDateToCalendar(date?: NgbDate) {
    const updatedDate =
      date == undefined
        ? this.dateAdapter.toModel(this.ngbCalendar.getToday())!
        : this.dateAdapter.toModel(date)!;
    return updatedDate;
  }

  convertFormat(y, m, d) {
    return y + '-' + m + '-' + d;
  }

  formatDateAll(date, type) {
    if (date == null) return;
    if (type == 'date') {
      this.tempDate = date.split('T')[0].split('-');
      return this.dateSrv.convertDateToLocaleString(
        this.tempDate[2],
        this.tempDate[1] - 1,
        this.tempDate[0]
      );
    } else {
      this.tempDate = date.split('T')[1].split(':');
      let type = this.tempDate[0] <= 12 ? 'AM' : 'PM';
      return this.tempDate[0] > 12
        ? this.tempDate[0] - 12 + ':' + this.tempDate[1] + ' ' + type
        : this.tempDate[0] + ':' + this.tempDate[1] + ' ' + type;
    }
  }

  gotoEditPage(id) {
    this.router.navigate(['/update-survey/' + id]);
  }

  getTheCouponsList() {
    this.pollsandsurveyService.getCouponList().subscribe((res) => {
      if (res?.isValid === true) {
        //this.mainCouponList = res?.list;
        this.mainCouponList = res?.list.filter((item: { isActive: any }) => {
          return item.isActive === true;
        });
      } else {
        this.mainCouponList = [];
      }
    });
  }

  getParkDetails(parkid) {
    this.pollsandsurveyService.getParkByCLAId().subscribe((res) => {
      if (res.isValid) {
        this.prakList = res.list;
        for (let i = 0; i <= this.prakList.length - 1; i++) {
          this.parkName = res.list.filter((obj: { parkId: any }) => {
            return obj.parkId == parkid;
          })['parkName'];
        }
      }
    });
  }

  goToEditPage(id) {
    this.router.navigate(['/update-survey-question/' + id]);
  }

  forceEdit() {
    this.showPreview = false;
  }

}
